/* ============================================================================
   COY TAKEOVER MENU (16 AUG)
   ----------------------------------------------------------------------------
   Behaviour only. All content is server rendered by sections/coy-menu.liquid, so
   this file holds no lists and needs no editing when the catalogue changes.

   INTERACTION MODEL
   Desktop: the header's own nav items open the panel on CLICK, at the section
     that was clicked. Not hover. Hover opening fires on the way to somewhere
     else and makes a full screen takeover feel like an accident; a takeover is
     a deliberate act, so it takes a deliberate click. Once open, hovering the
     names inside the panel switches sections.
   Mobile: the theme's burger opens the panel at level 1, a list of sections.
     The chevron drills into level 2, which gives that section the whole screen.
     Back returns. This is a drill down, not an accordion: an accordion makes you
     scroll past the sections you did not choose to reach the one you did.
     Level 2 reveals the SAME nodes the desktop columns use, stacked. There is
     one copy of the panel content in the page, not one per breakpoint.

   The section NAME is never hijacked on any breakpoint. It is a plain anchor to
   a real url and it navigates. Drilling in belongs to the chevron button beside
   it, so one target never carries two meanings.

   SEO: every link is a real <a href> in the server rendered HTML, and the header
   keeps its own hrefs, so the crawl path is unchanged whether or not JS runs.

   Pairs with assets/coy-menu.css.
   Rollback: remove the coy-menu section from sections/header-group.json.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__coyMenuInit) return;
  window.__coyMenuInit = true;

  function boot() {

    var root = document.querySelector('.coy-mn-root');
    if (!root) return;

    var menu   = root.querySelector('.coy-mn');
    var closeB = root.querySelector('.coy-mn__close');
    var backB  = root.querySelector('.coy-mn__back');
    var links  = [].slice.call(root.querySelectorAll('.coy-mn__link'));
    var items  = [].slice.call(root.querySelectorAll('.coy-mn__item'));
    var toggles= [].slice.call(root.querySelectorAll('.coy-mn__toggle'));
    var panels = [].slice.call(root.querySelectorAll('.coy-mn__panel'));
    var eds    = [].slice.call(root.querySelectorAll('.coy-mn__ed-item'));
    var slot   = root.querySelector('.coy-mn__ed-slot');
    var grid   = root.querySelector('.coy-mn__panels');
    if (!menu || !links.length) return;

    var swaps = [grid, slot].filter(Boolean);
    var active = 0;
    var lastFocus = null;
    var unmount = null;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function isMobile(){ return window.matchMedia('(max-width:1000px)').matches; }
    function canHover(){ return window.matchMedia('(hover:hover) and (pointer:fine)').matches; }

    /* fade images in as their bytes land, so a late load never pops */
    function watch(img){
      if (img.complete && img.naturalWidth) { img.classList.add('is-loaded'); return; }
      img.addEventListener('load',  function(){ img.classList.add('is-loaded'); }, {once:true});
      img.addEventListener('error', function(){ img.classList.add('is-loaded'); }, {once:true});
    }
    function watchAll(scope){
      [].forEach.call((scope || root).querySelectorAll('.coy-mn__img'), watch);
    }
    watchAll();

    /* ---------- randomised slots ----------
       The panel is rendered with a bigger pool than it shows: hero_n candidates
       for the big slot and per*2 cards, with the surplus carrying .is-extra so
       the no-JS view is the ranked top few, unchanged.

       Every open re-rolls it. The big slot takes a random candidate, the grid
       takes a random `per` of the pool, and any card pointing at the same href
       as the chosen hero is dropped first, which is what stops one brand from
       filling the large slot and a card at the same time. That href check
       replaced a fixed "skip rank 1" in the Liquid, which could not stay
       correct once the hero stopped always being rank 1. */
    function pick(heroScope, gridScope){
      /* Both scopes together, deliberately. The hero and the grid live in two
         separate containers (.coy-mn__ed-item and .coy-mn__panel), so calling
         this once per container meant the grid pass never saw a hero, heroHref
         stayed null, and the dedupe below silently did nothing: the chosen
         brand showed as the big slot AND as a card. */
      var heroes = heroScope ? [].slice.call(heroScope.querySelectorAll('.coy-mn__ed')) : [];
      var heroHref = null;
      if (heroes.length){
        var h = heroes[Math.floor(Math.random() * heroes.length)];
        heroHref = h.getAttribute('href');
        heroes.forEach(function(el){ el.classList.toggle('is-extra', el !== h); });
      }
      if (!gridScope) { watchAll(heroScope); return; }

      [].forEach.call(gridScope.querySelectorAll('.coy-mn__grid'), function(grid){
        var show  = parseInt(grid.getAttribute('data-show'), 10) || 4;
        var cards = [].slice.call(grid.children);
        var pool  = cards.filter(function(c){
          return !heroHref || c.getAttribute('href') !== heroHref;
        });
        /* Fisher Yates. Sorting on Math.random() is biased and, in some engines,
           an inconsistent comparator, which is a real source of odd orders. */
        for (var i = pool.length - 1; i > 0; i--){
          var j = Math.floor(Math.random() * (i + 1));
          var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
        }
        var keep = pool.slice(0, show);
        cards.forEach(function(c){ c.classList.add('is-extra'); });
        keep.forEach(function(c){ c.classList.remove('is-extra'); grid.appendChild(c); });
      });

      watchAll(gridScope);
      if (heroScope) watchAll(heroScope);
    }

    /* ---------- desktop: which section the two right columns show ---------- */
    function show(i){
      panels.forEach(function(p, n){ p.classList.toggle('is-active', n === i); });
      eds.forEach(function(e, n){ e.classList.toggle('is-active', n === i); });
      pick(eds[i], panels[i]);
      if (panels[i]) menu.setAttribute('data-active-kind', panels[i].getAttribute('data-kind') || '');
      watchAll();
    }

    function select(i){
      if (i === active) return;
      active = i;
      links.forEach(function(a, n){ a.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (reduced) { show(i); return; }
      swaps.forEach(function(el){ el.classList.add('is-out'); });
      setTimeout(function(){
        show(i);
        setTimeout(function(){
          swaps.forEach(function(el){ el.classList.remove('is-out'); });
        }, 20);
      }, 420);
    }

    /* ---------- mobile: drill down ---------- */
    function drillTo(i){
      active = i;
      items.forEach(function(li, n){ li.classList.toggle('is-open', n === i); });
      links.forEach(function(a, n){ a.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      toggles.forEach(function(b, n){ b.setAttribute('aria-expanded', n === i ? 'true' : 'false'); });
      menu.setAttribute('data-level', '2');
      /* show() is what makes the shared columns point at this section: it flips
         .is-active on the panel and the hero slot and re-rolls their contents.
         Level 2 used to have its own copy of the markup to reveal, so it only
         had to shuffle in place; now that there is a single copy, mobile has to
         drive the same switch desktop does or it would open on whichever
         section was last active. */
      show(i);
      if (backB) setTimeout(function(){ backB.focus(); }, 80);
    }

    function drillBack(){
      menu.setAttribute('data-level', '1');
      items.forEach(function(li){ li.classList.remove('is-open'); });
      toggles.forEach(function(b){ b.setAttribute('aria-expanded', 'false'); });
      var cur = toggles[active] || links[active];
      if (cur) setTimeout(function(){ cur.focus(); }, 80);
    }

    if (backB) backB.addEventListener('click', drillBack);

    /* ---------- the section names, and the chevron beside them ----------
       The name is a plain anchor and is never hijacked: it navigates, on every
       breakpoint, for people and crawlers alike. Drilling in is the chevron's
       job, which is why it is a separate button rather than a second meaning
       loaded onto the same target. */
    links.forEach(function(a, i){
      a.addEventListener('mouseenter', function(){ if (canHover() && !isMobile()) select(i); });
      a.addEventListener('focus', function(){ if (!isMobile()) select(i); });
    });

    toggles.forEach(function(btn, i){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        drillTo(i);
      });
    });

    /* ---------- open and close ---------- */
    function open(i){
      clearTimeout(unmount);
      lastFocus = document.activeElement;
      menu.setAttribute('data-level', '1');
      items.forEach(function(li){ li.classList.remove('is-open'); });
      if (typeof i === 'number') { active = i; show(i); links.forEach(function(a,n){ a.setAttribute('aria-current', n===i?'true':'false'); }); }
      menu.classList.add('is-mounted');
      void menu.offsetWidth;          // commit the start value
      menu.classList.add('is-open');  // no rAF: throttled in background tabs
      document.body.classList.add('coy-mn-locked');
      setTimeout(function(){ if (closeB) closeB.focus(); }, 80);
    }

    function close(){
      menu.classList.remove('is-open');
      document.body.classList.remove('coy-mn-locked');
      unmount = setTimeout(function(){
        menu.classList.remove('is-mounted');
        menu.setAttribute('data-level', '1');
        items.forEach(function(li){ li.classList.remove('is-open'); });
      }, 580);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    if (closeB) closeB.addEventListener('click', close);

    /* ---------- the header opens it, and the header is not modified ----------
       Mobile: the theme's burger. It is a <summary> inside <details>, so the
       click must be stopped before the native disclosure opens the old drawer.
       Desktop: the theme's inline nav. Clicking an item opens the panel at that
       section. The <a href> stays in the markup untouched, so the crawl path is
       identical; only the click is intercepted, and only when JS is running. */
    if (root.getAttribute('data-takeover') === 'true') {

      document.addEventListener('click', function(e){
        var t = e.target;
        if (!t || !t.closest) return;

        var burger = t.closest('.header__icon--menu, .menu-drawer__toggle, header-drawer summary');
        if (burger) {
          e.preventDefault();
          e.stopPropagation();
          var details = burger.closest('details');
          if (details) details.removeAttribute('open');
          open(0);
          return;
        }

        var navLink = t.closest('.header__inline-menu a');
        if (navLink && !isMobile()) {
          var label = (navLink.textContent || '').trim().toLowerCase();
          var idx = -1;
          for (var i = 0; i < links.length; i++) {
            if ((links[i].textContent || '').trim().toLowerCase() === label) { idx = i; break; }
          }
          if (idx > -1) {
            e.preventDefault();
            e.stopPropagation();
            open(idx);
          }
        }
      }, true);
    }

    document.addEventListener('keydown', function(e){
      if (!menu.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        if (isMobile() && menu.getAttribute('data-level') === '2') { drillBack(); }
        else { close(); }
        return;
      }

      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (isMobile()) return;
        e.preventDefault();
        var n = active + (e.key === 'ArrowDown' ? 1 : -1);
        if (n < 0) n = links.length - 1;
        if (n >= links.length) n = 0;
        select(n);
        links[n].focus();
      }

      if (e.key === 'Tab') {
        var f = menu.querySelectorAll('a[href], button');
        var vis = [];
        for (var j = 0; j < f.length; j++) { if (f[j].offsetParent !== null) vis.push(f[j]); }
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    show(0);
    menu.setAttribute('data-level', '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();